module.exports = __webpack_public_path__ + "img/featuredartist (2).194f8667.jpg";